import React from 'react'
import { nl2br } from '../../helpers/nl2br'

const PersonCard = ({ pictureUrl, name, title, phone, email }) => (
  <div className="flex items-center">
    <div
      className="flex-shrink-0 w-24 h-24 mr-3 bg-center bg-cover rounded-full bg-slate-300"
      style={{ backgroundImage: `url(${pictureUrl})` }}
    />
    <div className="u-p-small overflow-hidden">
      <div className="mb-3 font-bold">{title}</div>
      <div
        className="link-wrapper"
        dangerouslySetInnerHTML={{ __html: nl2br(name) }}
      />
      <div>{phone}</div>
      <div className="truncate">
        <a
          href={`mailto:${email}`}
          className="underline transition hover:text-red-as truncate"
          title={email}
        >
          {email}
        </a>
      </div>
    </div>
  </div>
)

export default PersonCard
